import { parseCellId } from '@cards/engine';
import { defineGameCard, onResolve, planningTargets, tableTarget, targetStep, } from '../authoring/index.js';
import { plannedTableId } from '../cards/plant-helpers.js';
export const SectorPulseCard = defineGameCard({
    id: 'sector_pulse',
    gameplay: {
        type: 'SPELL',
        cost: 5,
        planning: planningTargets([
            targetStep('location', tableTarget({ cardinality: { min: 1, max: 1 } })),
        ]),
    },
    presentation: {
        name: 'Импульс сектора',
        description: 'Нанесите 2 урона всем картам противника в выбранной локации.',
        glyph: {
            colors: ['#10213A', '#B0E9FF', '#84C8FD', '#2B6CD7', '#3D88E9'],
            rows: [
                '....................',
                '..........11........',
                '.......1112211......',
                '.....1122322221.....',
                '....122233244221....',
                '...12233222224221...',
                '...133222555224231..',
                '..12322255555522221.',
                '.1222255554155253231',
                '1222225551411152311.',
                '123325551151.11111..',
                '1333255114551.11....',
                '1353551114451.......',
                '15555511144431......',
                '1555555111444311....',
                '15551533111444331...',
                '1511.115331141111...',
                '.1.....114441.......',
                '.........111........',
                '....................',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [
        onResolve((ctx) => {
            const self = ctx.self;
            const tableId = plannedTableId(ctx, 'location');
            if (self === undefined || tableId === undefined)
                return;
            const targets = ctx.q.allUnits().filter((unit) => unit.controllerId !== self.controllerId
                && unit.cellId !== undefined
                && parseCellId(unit.cellId).tableId === tableId);
            for (const target of targets)
                ctx.ops.dealDamage({ kind: 'unit', instanceId: target.id }, 2);
        }),
    ],
    ui: { planning: { steps: { location: { label: 'Выберите локацию' } } } },
});
//# sourceMappingURL=sector-pulse.js.map